// get plain array with all allocated items
export const flattenAllocatedItems = (cartData) => {
  return Object.values(cartData).flatMap(value => {
    return value?.warehouses?.flatMap((warehouse) => {
      return warehouse.allocatedItems || [];
    }) ?? [];
  });
};